<template>
  <div class="notif-bell" @click="toggle">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
    <span v-if="unreadCount > 0" :class="['notif-badge', { pulse: hasUrgent }]">
      {{ unreadCount > 9 ? "9+" : unreadCount }}
    </span>
  </div>
</template>

<script>
export default {
  name: "NotifBell",
  computed: {
    unreadCount() {
      return this.$store.state.notificationsStore.unreadCount;
    },
    hasUrgent() {
      return this.$store.getters["notificationsStore/hasUrgent"];
    }
  },
  mounted() {
    this.$store.dispatch("notificationsStore/startPolling");
  },
  beforeDestroy() {
    this.$store.dispatch("notificationsStore/stopPolling");
  },
  methods: {
    toggle() {
      if (this.$store.state.notificationsStore.drawerOpen) {
        this.$store.dispatch("notificationsStore/closeDrawer");
      } else {
        this.$store.dispatch("notificationsStore/openDrawer");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notif-bell {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #31355c;
  transition: background 0.15s;
  margin-right: 6px;
  &:hover {
    background: #f0f2f7;
  }
}
.notif-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #e24b4a;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid #fff;
  line-height: 1;
}
.notif-badge.pulse {
  animation: badge-pulse 2s infinite;
}
@keyframes badge-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}
</style>
